// extracted by mini-css-extract-plugin
export default {"header":"CoinModal_header__uH49B","modal_main":"CoinModal_modal_main__Og0Hg","coin_info":"CoinModal_coin_info__yVgJn","balance":"CoinModal_balance__xKVnG"};